import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'huonepalvelu',
      [RoomServiceLocationType.TableService]: 'pöytäpalvelu',
    },
    [ORDER_METHODS.PICKUP]: 'nouto',
    [ORDER_METHODS.DELIVERY]: 'toimitus',
  },
  errors: {
    draft_validation_failed: 'Täytä toimitusosoite ennen jatkamista.',
  },
};
